<template>
  <v-btn id="publish-job" :href="adminUrl" text class="ma-0 pa-0 primary--text">
    <span class="btn-text">{{ userNavbar.value }}</span>
  </v-btn>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';

export default {
  data() {
    return {
      userNavbar: t('titles.userLoginMenu'),
    };
  },
  computed: {
    adminUrl() {
      return process.env.adminUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  display: flex;
  width: 130px;
  border: 1px solid #ff7100;
  border-radius: 30px;
  flex-direction: column;
  justify-content: center;
  padding: 0px, 12px, 0px, 18px;
  font-size: 15px;
  text-align: center;
  margin: 0 5px;

  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: center;
}
.btn-text-icon {
  display: inline-block;
  font-size: 20px;
  margin: 0 0 2px 5px;
}
#publish-job div > span {
  border-radius: 5px;
}

#publish-job:hover {
  color: #3e4a54 !important;
  border: 1px solid #3e4a54;
}

#publish-job:hover * {
  color: #3e4a54 !important;
}

#publish-job:hover .icon-megaphone-7:before {
  color: #3e4a54 !important;
}

@media screen and (max-width: 1280px) {
  a {
    // width: 90px;
    font-size: 15px;
  }

  .btn-text {
    font-size: 14px;
  }
}

@media screen and (max-width: 1160px) {
}

@media screen and (max-width: 768px) {
}

@media screen and (max-width: 480px) {
  #publish-job {
    display: none;
  }
}
</style>
